import { render, staticRenderFns } from "./scrollBox.vue?vue&type=template&id=7588ed96&scoped=true&"
import script from "./scrollBox.vue?vue&type=script&lang=js&"
export * from "./scrollBox.vue?vue&type=script&lang=js&"
import style0 from "./scrollBox.vue?vue&type=style&index=0&id=7588ed96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7588ed96",
  null
  
)

export default component.exports